import { Link, NavLink } from 'react-router-dom';
import { QrCode } from 'lucide-react';

const navLinkClass = ({ isActive }) =>
  `text-sm font-medium transition ${
    isActive ? 'text-indigo-600' : 'text-slate-600 hover:text-slate-900'
  }`;

export default function Header() {
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="flex items-center gap-2 font-semibold text-slate-900"
          aria-label="PixelUtility QR – Free QR Code Generator home"
        >
          <span
            className="flex h-9 w-9 items-center justify-center rounded-lg bg-indigo-600 text-white"
            aria-hidden
          >
            <QrCode className="h-5 w-5" />
          </span>
          <span>
            PixelUtility <span className="text-slate-500 font-normal">QR</span>
          </span>
        </Link>
        <nav className="flex items-center gap-6" aria-label="Main">
          <NavLink to="/" end className={navLinkClass}>
            Generator
          </NavLink>
          <a href="/#faq" className="text-sm font-medium text-slate-600 hover:text-slate-900">
            FAQ
          </a>
        </nav>
      </div>
    </header>
  );
}
